exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".SimpleButton__root__14kwp{min-width:0!important;padding:0;text-transform:none!important}.SimpleButton__label__2O_2d{height:100%;width:100%}", "", {"version":3,"sources":["/mnt/d/asofts/vvs/cirrus/Cirrus/frontend/src/components/controls/buttons/src/components/controls/buttons/SimpleButton.scss"],"names":[],"mappings":"AAAA,2BACE,sBAA6B,AAC7B,UAAU,AACV,6BAA+B,CAChC,AACD,4BACE,YAAY,AACZ,UAAW,CACZ","file":"SimpleButton.scss","sourcesContent":[".root {\n  min-width: initial !important;\n  padding: 0;\n  text-transform: none !important;\n}\n.label {\n  height: 100%;\n  width: 100%;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"root": "SimpleButton__root__14kwp",
	"label": "SimpleButton__label__2O_2d"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-2!./node_modules/sass-loader/lib/loader.js??ref--1-3!./src/components/controls/buttons/SimpleButton.scss
// module id = ./node_modules/css-loader/index.js??ref--1-2!./node_modules/sass-loader/lib/loader.js??ref--1-3!./src/components/controls/buttons/SimpleButton.scss
// module chunks = 0